export default __webpack_public_path__ + "static/media/Statue-of-the-Jain-Tirthankar-Mahavir.c3ebf79e.jpg";